export const memberProfile = {
  "verified": "Verificado",
  "online": "Conectado",
  "memberSince": "Membro desde",
  "contact": "Contatar",
  "share": "Compartilhar",
  "respondsIn": "Responde em",
  "responseRate": "de resposta",
  "exchangesCompleted": "Trocas realizadas",
  "reviews": "avaliações",
  "responseRateLabel": "Taxa de resposta",
  "memberSinceLabel": "Membro desde",
  "years": "anos",
  "year": "ano",
  "exchangeHistory": "Histórico de trocas",
  "property": "Alojamento",
  "reviewsTab": "Avaliações",
  "all": "Todas",
  "completed": "Concluídas",
  "upcoming": "Futuras",
  "cancelled": "Canceladas",
  "exchangeWith": "Troca com",
  "nights": "noites",
  "noExchangeInCategory": "Nenhuma troca nesta categoria",
  "offeredProperty": "Alojamento proposto",
  "memberReviews": "Avaliações dos membros"
};
